const SubscriptionSource = require("../source/SubscriptionSource");
const alt = require('../alt');

class SubscribeActions {
    addSubscription(email, name) {
        SubscriptionSource.addSubscription(email, name)
            .then((response) => {
                this.showSubscribed(response);
            })
            .catch((error) => {
                console.log("Error: " + error);
            });
    }

    showSubscribed(responce) {
        return responce;
    }

    closeShowConfirmed(){
        return false;
    }
}

module.exports = alt.createActions(SubscribeActions);


// WEBPACK FOOTER //
// ./src/actions/SubscribeActions.jsx